import classNames from 'clsx'
import { bool, node, shape, string } from 'prop-types'

import { TENANT_AT } from 'shared/consts'
import { isRebrandingActive } from 'shared/experiments/utils/rebranding'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { publicRuntimeConfigType } from 'views/utils/propTypes'
import { usePageProperties } from 'views/utils/shopAndRuntimeConfigUtils'

import './CircleBadge.scss'

const CircleBadge = props => {
  const {
    children,
    color,
    showSupNotes,
    supNoteNumber,
    smaller,
    medium,
    fullwidth,
    ellipse,
    className,
    rounded,
    border,
    bonus,
    bold,
    publicRuntimeConfig: {
      publicConfig: { superScripts, tenant },
    },
  } = props
  const { experiments } = usePageProperties()
  const showSup =
    showSupNotes && !isRebrandingActive(experiments) && tenant !== TENANT_AT
  const superScriptValue = superScripts?.supNoteNumber || supNoteNumber

  const classes = classNames(
    'a-CircleBadge',
    className,
    `u-background-color--${color}`,
    {
      'a-CircleBadge--fullwidth': fullwidth,
      'a-CircleBadge--smaller': smaller,
      'a-CircleBadge--medium': medium,
      'a-CircleBadge--ellipse': ellipse,
      'a-CircleBadge--circle': !ellipse && !rounded,
      'a-CircleBadge--rounded': rounded,
      'a-CircleBadge--border--transparent': border,
      'a-CircleBadge--bonus': bonus,
      'u-font-weight--bold': bold,
    }
  )

  return (
    <span className={classes}>
      <span className="a-CircleBadge__inner">
        {children}
        {showSup && (
          <sup className="a-CircleBadge__inner__content">
            {superScriptValue}
          </sup>
        )}
      </span>
    </span>
  )
}

CircleBadge.propTypes = {
  children: node.isRequired,
  publicRuntimeConfig: shape(publicRuntimeConfigType).isRequired,
  color: string,
  showSupNotes: bool,
  supNoteNumber: string,
  smaller: bool,
  medium: bool,
  fullwidth: bool,
  ellipse: bool,
  className: string,
  rounded: bool,
  border: bool,
  bonus: bool,
  bold: bool,
}

CircleBadge.defaultProps = {
  color: 'red',
  showSupNotes: true,
  // if for some reason, current tenant doesn't have superscript
  // in the shopConfig, it will default to old hardcoded value
  supNoteNumber: '2',
  smaller: false,
  medium: false,
  fullwidth: false,
  ellipse: false,
  className: null,
  rounded: false,
  border: false,
  bonus: false,
  bold: false,
}

export default withShopAndRuntimeConfig(CircleBadge)
